"use client";

// "Setup required" notice — generic copy + a link to the resolved setup
// guide (a doc URL). Rendered between the Server URL field and Advance Settings
// in both the Add MCP modal and the Edit MCP drawer.

import { useTranslations } from "next-intl";
import { domId } from "@/lib/dom-id";
import { InlineStatus } from "@/components/ui/inline-status";

export function McpSetupInstruction({
  purpose,
  url,
}: {
  purpose: string;
  url: string;
}) {
  const tMcp = useTranslations("Mcp");
  return (
    <InlineStatus
      purpose={`${purpose}-instruction`}
      data-testid={domId("sec", `${purpose}-instruction`)}
      status="warning"
      title={tMcp("instruction.heading")}
    >
      <p className="mb-2">{tMcp("instruction.body")}</p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={domId("lnk", `${purpose}-instruction`)}
        className="font-medium text-blue-600 underline hover:text-blue-700"
      >
        {tMcp("instruction.link")}
      </a>
    </InlineStatus>
  );
}
